import React, { useEffect, useState} from "react";
import { Typography } from "@mui/material";
import Learn from "./Learn";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const RegisterPage = {
    RESEARCH: 0
};

const RegisterSelectionButton = styled(Button)(({ theme }) => ({
    color: "#fff",
    backgroundColor: "rgb(5, 27, 63)",
    height: 72,
    width: "100%",
    borderRadius: 0,
    textTransform: "none",
    '&:hover': {
        backgroundColor: "rgb(0, 0, 0)",
    },
}));

export default function Register(props) {
    const [signupConfig, setSignupConfig] = useState(["RESEARCH"]);
    const [signupAllowedDomain, setSignupAllowedDomain] = useState([]);
    const [currentRegisterPage, setCurrentRegisterPage] = useState("");

    const handleChange = (newPage) => {
        setCurrentRegisterPage(newPage);
    };

    // useEffect(() => {
    //     GetSignupConfig().then(res => {
    //         try {
    //             setSignupConfig(res.data.data);
    //         } catch {
    //             setSignupConfig(["LEARN"]);
    //         }
    //     })
    // }, []);
    //
    // useEffect(() => {
    //     GetSignupAllowedDomain().then(res => {
    //         try {
    //             setSignupAllowedDomain(res.data.data);
    //         } catch {
    //             setSignupAllowedDomain(["terawe.com"]);
    //         }
    //     })
    // }, []);
    
    useEffect(() => {
        setCurrentRegisterPage(RegisterPage[signupConfig[0]]);
    },[signupConfig])

    return (
        <React.Fragment><div className="tabsMainCon">
            <div className="tmcHead">
                {
                    signupConfig.includes("RESEARCH") ? <RegisterSelectionButton className={currentRegisterPage === RegisterPage.RESEARCH ? 'active' : ""} onClick={() => handleChange(RegisterPage.RESEARCH)}>
                        <Typography fontSize={32} fontWeight={400} style={{ display: "inline-flex" }}>
                            Sign up to get access to a free trial!
                        </Typography>
                    </RegisterSelectionButton> : <React.Fragment />
                }
            </div>
            <div className="tmcBody">
                {
                    (() => {
                        switch (currentRegisterPage) {
                            case RegisterPage.RESEARCH:
                                return <Learn {...props} signupAllowedDomain={signupAllowedDomain} />
                            default:
                                return <div>Nothing to show</div>
                        }
                    })()
                }
            </div>
        </div>
        </React.Fragment>
    );
}